import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import Media from 'react-media'
import NRTButton from "../../_common/_buttons/Button"
import ArrowRight from "../../_common/_icons/ArrowRight"

const ContentTitle = (props) => {
    const {
        title,
        prevContent,
        nextContent,
        onPrevContentButtonClick,
        onNextContentButtonClick,
        blockNextContentButton,
    } = props
    return (
        <div className='nrt-ead-content-title'>

            <NRTButton
                disabled={!prevContent}
                style={{opacity: prevContent ? 1 : 0, flexDirection: 'column'}}
                onClick={()=>onPrevContentButtonClick(prevContent)}
                iconButton
            >
                <div>
                    <ArrowRight transform={"rotate(180 0 0)"}/>
                    {prevContent && <span>{prevContent.name}</span>}
                </div>
                <Media query="(min-width: 425px)">
                       {matches => matches ? <span style={{ paddingTop: '0.5rem', fontSize: '0.5rem' }}>Conteúdo anterior</span> : null}
                </Media> 
            </NRTButton>


            <h1>{title}</h1>


            <NRTButton
               disabled={!nextContent}
               style={{opacity: nextContent ? 1 : 0,
                   flexDirection: 'column',
                    cursor: blockNextContentButton ? 'not-allowed' : 'pointer'
               }}
               onClick={()=>{
                   if (blockNextContentButton) return
                   onNextContentButtonClick(nextContent)
               }}
               iconButton
            >
                <div>
                    {nextContent && <span>{nextContent.name}</span>}
                    <ArrowRight/>
                </div>
                <Media query="(min-width: 425px)">
                       {matches => matches ? <span style={{ paddingTop: '0.5rem', fontSize: '0.5rem' }}>Próximo conteúdo</span> : null}
                </Media> 
            </NRTButton>

        </div>
    )
}

ContentTitle.propTypes = {
    title: PropTypes.string.isRequired,
    prevContent: PropTypes.shape({
        title: PropTypes.string,
    }),
    nextContent: PropTypes.shape({
        title: PropTypes.string,
    }),
    onPrevContentButtonClick: PropTypes.func,
    onNextContentButtonClick: PropTypes.func,
}

ContentTitle.defaultProps = {
    prevContent: {},
    nextContent: {},
}

export default ContentTitle



// WEBPACK FOOTER //
// ./src/components/_ead/ContentTitle/index.js